import axios from "axios";
import { useState } from "react";
import { Building2, Check, Pencil, Plus, Trash2, X } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AccountManager({ accounts, onChanged }) {
  const [name, setName] = useState("");
  const [notice, setNotice] = useState("");
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const [pendingDelete, setPendingDelete] = useState(null);

  const call = async (fn, ok) => {
    try { await fn(); setNotice(ok); onChanged?.(); }
    catch (e) { setNotice(e?.response?.data?.detail || "İşlem başarısız"); }
  };

  const add = event => {
    event.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    call(() => axios.post(`${API}/accounts`, { name: trimmed }), `Hesap eklendi: ${trimmed}`).then(() => setName(""));
  };

  const rename = account => {
    const next = draft.trim();
    setEditing(null);
    if (!next || next === account) return;
    call(() => axios.put(`${API}/accounts/${encodeURIComponent(account)}`, { name: next }), `Hesap yeniden adlandırıldı: ${next}`);
  };

  const confirmDelete = () => {
    const account = pendingDelete;
    setPendingDelete(null);
    call(() => axios.delete(`${API}/accounts/${encodeURIComponent(account)}`), `Hesap silindi: ${account}`);
  };

  return (
    <section className="panel account-manager" data-testid="account-manager">
      <div className="panel-head">
        <div>
          <p className="eyebrow">HESAPLAR</p>
          <h3>Otel / cari hesapları</h3>
        </div>
        <Building2 size={18}/>
      </div>
      <form onSubmit={add} className="group-form">
        <input data-testid="new-account-input" placeholder="Ör: Calista Resort" value={name} onChange={e => setName(e.target.value)}/>
        <button className="outline-btn" data-testid="add-account-button" type="submit"><Plus size={16}/> Ekle</button>
      </form>
      <div className="group-chips" data-testid="account-chips">
        {accounts.map(account => editing === account ? (
          <span key={account} className="group-tag editing" data-testid={`account-edit-${account}`}>
            <input autoFocus data-testid="account-rename-input" value={draft} onChange={e => setDraft(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); rename(account); } if (e.key === "Escape") setEditing(null); }}/>
            <button type="button" className="chip-btn" data-testid="account-rename-save" title="Kaydet" onClick={() => rename(account)}><Check size={12}/></button>
            <button type="button" className="chip-btn" data-testid="account-rename-cancel" title="Vazgeç" onClick={() => setEditing(null)}><X size={12}/></button>
          </span>
        ) : (
          <span key={account} className="group-tag income" data-testid={`account-chip-${account}`}>
            {account}
            <button type="button" className="chip-btn" title="Yeniden adlandır" data-testid={`account-rename-${account}`}
              onClick={() => { setEditing(account); setDraft(account); }}><Pencil size={11}/></button>
            <button type="button" className="chip-btn danger" title="Sil" data-testid={`account-delete-${account}`}
              onClick={() => setPendingDelete(account)}><Trash2 size={11}/></button>
          </span>
        ))}
      </div>
      <small className="hint">Gelir ve tahsilat kayıtları hesaba bağlanır; giderler hesap bazında ayrıştırılmaz. Kaydı olan hesap silinemez.</small>
      {notice && <small data-testid="account-notice" className="group-notice">{notice}</small>}

      <AlertDialog open={!!pendingDelete} onOpenChange={open => !open && setPendingDelete(null)}>
        <AlertDialogContent data-testid="account-delete-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Hesap silinsin mi?</AlertDialogTitle>
            <AlertDialogDescription>
              <b>{pendingDelete}</b> silinecek. Bu hesaba bağlı gelir veya tahsilat varsa silme işlemi reddedilir.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="account-delete-cancel">Vazgeç</AlertDialogCancel>
            <AlertDialogAction data-testid="account-delete-confirm" className="danger-action" onClick={confirmDelete}>Evet, sil</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
}
